import React, { useState } from "react";
import areObjectsEqual from "../../../../utils/areObjectsEqual";
import Dropdown from "../../../Common/Dropdown";
import { convertCryptoToUSD } from '../../../../utils/formatPriceNft';

/**
 * Form Component
 * Form for adding or editing background price information
 */
const Form = ({ formData, handleSubmit, onDiscard, rankList, isEdit, cryptoPrice }) => {
  const [form, setForm] = useState(formData);
  const [copyData] = useState({ ...formData });
  const [errors, setErrors] = useState({ rank: false, price: false });

  const hasUnsavedChanges = areObjectsEqual(copyData, form);

  /**
   * Handle formatted price
   */
  const priceInUSD = convertCryptoToUSD(form.price, cryptoPrice);

  /**
   * Handle input changes
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  /**
   * Handle dropdown changes
   */
  const handleDropdownChange = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors.rank) {
      setErrors((prev) => ({ ...prev, rank: false }));
    }
  };

  /**
   * Validate form
   */
  const validateForm = () => {
    const newErrors = {
      rank: !form.rank,
      price: !form.price || parseFloat(form.price) <= 0,
    };
    setErrors(newErrors);
    return !newErrors.rank && !newErrors.price;
  };

  /**
   * Handle form submission
   */
  const handleClick = () => {
    if (validateForm()) {
      handleSubmit(form);
    }
  };

  return (
    <>
      <div className="mt-4">

        {isEdit ? (
          <>
            <label htmlFor="rank" className="form-labels">
              Rank
            </label>
            <input
              type="text"
              name="rank"
              id="rank"
              value={form.rank}
              className="form-control inputs"
              disabled
            />
          </>
        ) : (
          <>
            <label htmlFor="rank" className="form-labels">
              Color
            </label>
            <Dropdown
              category="backgroundPrice"
              categorySubType="background"
              dropdownList={rankList}
              handleChange={handleDropdownChange}
              dropdownHeader={
                form.rank && form.color
                  ? `${form.color} #${form.rank}`
                  : "Select Background Price"
              }
            />
          </>
        )}
        {errors.rank && (
          <span className="form-text text-danger">Color is required</span>
        )}
      </div>

      <div className="mt-4">
        <label htmlFor="price" className="form-labels">
          Price in AVAX
        </label>
        <input
          type="number"
          name="price"
          id="price"
          min={0.01}
          step={0.01}
          onChange={handleChange}
          value={form.price}
          className="form-control inputs"
        />
        {errors.price && (
          <span className="form-text text-danger">
            Price in AVAX is required
          </span>
        )}
        <span className="form-text text-muted">
          {priceInUSD} USD
        </span>
      </div>

      <div className="pt-5">
        <button
          type="button"
          className="btn btn-secondary me-4 form-btn"
          onClick={onDiscard}
        >
          Discard
        </button>
        <button
          type="button"
          className="btn bg-orange form-btn"
          onClick={handleClick}
          disabled={hasUnsavedChanges}
        >
          Save Changes
        </button>
      </div>
    </>
  );
};

export default Form;